import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.includes.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { ref, computed } from "vue";
import { defineStore } from "pinia";
import { defaultSearchBeanValues, getDefaultSearchBean } from "@wikicasa/common/model/RealEstateSearchBean";
//@ts-ignore
import { getRealEstateCounter } from "@services/realEstateAPI";
export var useSearchBeanStore = defineStore("searchBeanStoreId", () => {
  var realEstateSearchBean = ref(getDefaultSearchBean());
  var realEstateCounter = ref(0);
  var searchBean = computed(() => realEstateSearchBean.value);
  var hasPlace = computed(() => !!realEstateSearchBean.value.cityURL || !!realEstateSearchBean.value.polygonFromMap);
  var setRealEstateCounter = newCounter => {
    realEstateCounter.value = newCounter;
  };
  var setSearchBean = searchBean => {
    realEstateSearchBean.value = searchBean;
  };
  var setSearchBeanByKey = payload => {
    realEstateSearchBean.value[payload.key] = payload.value;
  };
  var updateSearchBean = payload => {
    for (var key in payload) {
      //It may happen that listingTypologuId and listingTypologyIdList are null...
      //...well, in that case, we will set the default values!
      if ([null, undefined].includes(payload[key])) {
        var defaultValue = defaultSearchBeanValues[key];
        if (defaultValue !== undefined) {
          realEstateSearchBean.value[key] = defaultValue;
          continue;
        }
      }
      realEstateSearchBean.value[key] = payload[key];
    }
  };
  var updateRESBCounter = resb => __awaiter(void 0, void 0, void 0, function* () {
    var counter = yield getRealEstateCounter(resb);
    realEstateCounter.value = counter !== null && counter !== void 0 ? counter : 0;
  });
  return {
    realEstateSearchBean,
    realEstateCounter,
    searchBean,
    hasPlace,
    setRealEstateCounter,
    setSearchBean,
    setSearchBeanByKey,
    updateSearchBean,
    updateRESBCounter
  };
});